import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { logoutUser } from '../redux/slices/authSlice';
import useInactivityLogout from '../hooks/useInactivityLogout';

/**
 * Renders nothing. Logs out admin after 30 min inactivity when authenticated.
 */
export default function InactivityLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogout = useCallback(() => {
    toast.error('Sesiune expirată din cauza inactivității (30 min).');
    dispatch(logoutUser());
    navigate('/login');
  }, [dispatch, navigate]);

  useInactivityLogout(handleLogout, isAuthenticated);
  return null;
}
